// 22.01.19 - This component just shows the intro text to the users.
import * as React from "react";
import { Divider, Grid, withStyles, WithStyles } from "@material-ui/core"; //Typography,
import { generalStyles } from "src/styles/general";
import { IUserDetail } from "src/constants/api";
import { FlexGridItem } from "../detail/form_utility";

interface IHeaderStateProps {
  currentUser?: IUserDetail;
}
type IntroProps = IHeaderStateProps & WithStyles<typeof generalStyles>;

class IntroComponent extends React.Component<IntroProps, {}> {
  constructor(props: IntroProps) {
    super(props);
  }

  public render() {
    return (
      <Grid container={true} spacing={2} >
        <FlexGridItem xs={12} className="headerTextAlignCenter">
          <h2>Complaints & Insurance Claims Application (CICA)</h2>
        </FlexGridItem>
        <Divider className="hrDashed" />
        <FlexGridItem xs={12}>
          <Grid container={true} spacing={2} style={{ marginTop: "5px" }}>
            <FlexGridItem xs={6} item className="headerTextAlignCenter">
              <h3>Standard UNICEF Complaints & Claims</h3>
              <div style={{ lineHeight: "20px", fontSize: "14px" }}>
                <p>
                  The Complaints & Insurance Claims Application (CICA) supports UNICEF
                  offices and partners to submit cases for complaints and insurance
                  claims and to check their status.
                </p>
                <p>
                  To log a new case or to check the status of your previous cases
                  please click on the relevant link in the top menu.
                </p>
                <p>
                  For suppliers, partners and other external case submitters please
                  contact{" "}
                  <a href="mailto:sd.complaints@unicef.org ">
                    UNICEF Supply Division
                  </a>
                </p>
              </div>
            </FlexGridItem>
            {<Divider className="hrDashed" orientation="vertical" />}
            <FlexGridItem xs={5} item className="headerTextAlignCenter">
              {/* <h3>UNICEF/GAVI Covax Incident Reporting</h3>
              <div style={{ lineHeight: "20px", fontSize: "14px" }}>
                <p>
                  The (CICA) Incident Reporting application supports UNICEF partners to submit Covax related incidents for physical loss or damage to check their status
                </p>
                <p>
                  For partners and other external submitters, please forward your case by mail to UNICEF supply Division
                  {" "}
                  <a href="mailto:cargoalert@unicef.org">
                    cargoalert@unicef.org
                  </a>
                </p>
              </div> */}
            </FlexGridItem>
          </Grid>
        </FlexGridItem>
      </Grid>
    );
  }
}
export default withStyles(generalStyles)(IntroComponent);
